module.exports = __webpack_public_path__ + "static/media/picture.652c3ffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/picture.jpg
// module id = 157
// module chunks = 0